<template>
  <CreateDialog
    max-width="500"
    v-model="model"
    :loading="loading"
    @reject="model = false"
    @success="onSuccess"
  >
    <template #title> Create Student </template>
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-form ref="form">
      <v-card-text>
        <v-text-field
          v-model="crud.first_name"
          label="First Name"
          outlined
          dense
          :rules="[(v) => !!v || 'Name required']"
        />
        <v-text-field
          v-model="crud.last_name"
          label="Last Name"
          outlined
          dense
          :rules="[(v) => !!v || 'Last Name required']"
        />
        <v-text-field
          v-model="crud.email"
          label="Email"
          outlined
          dense
          :rules="[(v) => !!v || 'Email required', rules.email]"
        />
        <v-select
          v-model="crud.level"
          label="Levels"
          multiple
          item-text="name"
          item-value="uuid"
          :items="levels"
          outlined
          dense
        />
        <PasswordField
          v-model="crud.password"
          label="Password"
          outlined
          autocomplete="new-password"
          dense
          :rules="[(v) => !!v || 'Password required']"
        />
      </v-card-text>
    </v-form>
  </CreateDialog>
</template>
<script>
import PasswordField from "../PasswordField.vue";
import { postStudentsJson } from "@/api/api";
import { rules } from "@/mixins/rulesMixin";
import CreateDialog from "../CreateDialog.vue";
export default {
  components: { PasswordField, CreateDialog },
  props: {
    contact: Object,
    value: Boolean,
    levels: Array,
  },
  data() {
    return {
      model: false,
      crud: {
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        email: this.contact.email,
        username: "",
        password: "",
        contact: this.contact.uuid,
        level: [],
      },
      loading: false,
      rules,
    };
  },
  methods: {
    async onSuccess() {
      this.loading = true;
      try {
        const response = await postStudentsJson({ ...this.crud, username: this.crud.email });
        this.$emit("new-student", response.data);
        this.model = false;
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    model(value) {
      this.$emit("input", value);
      if (value) {
        this.crud = {
          first_name: this.contact.first_name,
          last_name: this.contact.last_name,
          email: this.contact.email,
          username: "",
          password: "",
          contact: this.contact.uuid,
        };
        this.$refs.form?.resetValidation();
      }
    },
    value(value) {
      this.model = value;
    },
  },
};
</script>
